<template>
    <div>
        <base-header type="gradient-success" class="pb-6 pb-6 pt-5 pt-md-5">
        </base-header>
        <div class="container-fluid mt-5">
            <div class="card">
                <div class="content card-header">
                    <h1>Registrar Atributo</h1>
                    <base-button type="primary" icon size="sm" @click="$router.back()">
                        <i class="fas fa fa-arrow-left mr-2"></i>
                        <span class="btn-inner--text">Regresar</span>
                    </base-button>
                </div>
                <div class="card-body">
                    <form role="form" @submit.prevent="handleSubmit()">

                        <div class="row">
                            <div class="col-lg-6">
                                <base-input label="Título" placeholder="" v-model="title" />
                                <validation-error :errors="apiValidationErrors.title" />
                            </div>
                            <div class="col-lg-5">
                                <base-input label="Ícono">

                                    <select v-model="icon" class="form-control" data-show-content="true">
                                        <option v-for="option in iconsOptions" :key="option.name" :label="option.name"
                                            :value="option.name">
                                        </option>
                                    </select>
                                </base-input>

                            </div>
                            <div class="col-lg-1">
                                <ion-icon :name="icon" size="large" class="icon-select"></ion-icon>
                            </div>

                            <div class="col-lg-6">
                                <base-input label="Tipo">
                                    <select v-model="typeInput" class="form-control" @change="handleTypeChange">
                                        <option v-for="option in types" :key="option.id" :value="option">
                                            {{ option.id }} - {{ option.description }}
                                        </option>
                                    </select>
                                </base-input>
                                <validation-error :errors="apiValidationErrors.typeInput" />
                            </div>

                            <div class="col-lg-6">
                                <base-input label="Obligatorio">
                                    <base-switch :value="obligatorio" class="ml-3" on-text="Si" off-text="No"
                                        @change="handleSwitchChange"></base-switch>
                                </base-input>
                                <!-- <validation-error :errors="apiValidationErrors.obligatorio" /> -->
                            </div>

                            <div class="col-lg-6">
                                <base-input label="Valor del input">
                                    <textarea class="form-control" rows="5" v-model="contenido"
                                        :disabled="disabled"></textarea>
                                </base-input>
                                <!-- <validation-error :errors="apiValidationErrors.contenido" /> -->
                            </div>

                            <div class="col-lg-6">
                                <base-input label="Familia">
                                    <select v-model="family" class="form-control">
                                        <option v-for="option in families" :key="option.id" :value="option.id">
                                            {{ option.id }} - {{ option.title }}
                                        </option>
                                    </select>
                                </base-input>
                                <validation-error :errors="apiValidationErrors.family" />
                            </div>

                            <div class="col-lg-6">
                                <base-input label="Orden Atributo">
                                    <select v-model="orden" class="form-control">
                                        <option v-for="option in ordenOptions" :key="option" :label="option"
                                            :value="option">
                                        </option>
                                    </select>
                                </base-input>
                                <validation-error :errors="apiValidationErrors.orden" />
                            </div>

                            <div class="col-lg-6">
                                <base-input label="Columna Dashboard">
                                    <select v-model="columns" class="form-control">
                                        <option v-for="option in columnOptions" :key="option" :label="option"
                                            :value="option">
                                        </option>
                                    </select>
                                </base-input>
                                <validation-error :errors="apiValidationErrors.columns" />
                            </div>


                            <div class="col-lg-6">
                                <base-input label="Subtotable">
                                    <base-switch class="ml-3" on-text="" off-text="" :value="subtotable"
                                        @change="handleSwitchChangeSubtotable"></base-switch>
                                </base-input>
                                <validation-error :errors="apiValidationErrors.obligatorio" />
                            </div>
                        </div>

                        <div class="text-center">
                            <base-button type="primary" native-type="submit" class="my-4">Guardar</base-button>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </div>
</template>
   
<script>

import router from "@/router";
import ValidationError from "@/components/ValidationError.vue";
import formMixin from "@/mixins/form-mixin";
import * as moment from 'moment';
import lisServices from '../../store/services/getList-service';
import { Select, Option } from 'element-ui'

export default {
    components: {
        ValidationError,
        [Select.name]: Select,
        [Option.name]: Option
    },
    mounted() {
        console.log('Component mounted')
        this.getFamilies();
        this.getInputs();
        this.getLisApiIcons();
    },
    mixins: [formMixin],
    data() {
        return {
            title: null,
            typeInput: null,
            obligatorio: false,
            contenido: null,
            orden: null,
            icon: null,
            family: null,
            subtotable: false,
            columns: null,
            families: [],
            types: [],
            ordenOptions: [1, 2, 3, 4, 5, 6, 7, 8, 9, 10],
            columnOptions: [1, 2, 3, 4],
            iconsOptions: [],
            disabled: false
        };
    },

    methods: {
        showScore(score) {
            this.scors = score;
        },
        async getFamilies() {
            let response = await lisServices.getListFamilies();
            console.log(response);

            this.families = response.list;
            console.log('Families', this.families);
        },
        async getInputs() {
            let response = await lisServices.getListInputs();
            console.log('Inputs', response);

            this.types = response.list;
            console.log(this.types);
        },
        async handleSubmit() {

            const data = {
                title: this.title,
                typeInput: this.typeInput?.id,
                obligatorio: this.obligatorio,
                contenido: this.contenido,
                orden: this.orden,
                icon: this.icon,
                family: this.family,
                subtotable: this.subtotable,
                columns: this.columns,
            };

            console.log('QUERY ->', data);

            try {
                let response = await lisServices.saveAttribute(data);
                console.log(response);


                if (response.success) {
                    this.$notify({
                        type: "success",
                        message: "¡Operación ejecutada correctamente!",
                    });
                    router.push({ path: '/modules/attributes' });
                } else {
                    this.$notify({
                        type: "danger",
                        message: response.message,
                    });
                }

            } catch (error) {
                console.log(error)
                this.$notify({
                    type: "danger",
                    message: "¡Error en la ejecución de la operación!",
                });
            }
        },
        handleSwitchChange(newValue) {

            this.obligatorio = newValue.target.checked;
            console.log(this.obligatorio)

        },
        handleSwitchChangeSubtotable(newValue) {

            this.subtotable = newValue.target.checked;
            console.log(this.subtotable)

        },

        handleTypeChange() {

            const body = [
                {
                    "id": 1,
                    "name": "Ejemplo1"
                },
                {
                    "id": 2,
                    "name": "Ejemplo2"
                },
            ]
            console.log('value ->', this.typeInput);
            if (this.typeInput.description == 'time' || this.typeInput.description == 'date') {
                this.contenido = moment().format();
                this.disabled = true;
            } else if (this.typeInput.description == 'select') {
                this.contenido = JSON.stringify(body);
                this.disabled = false;
            } else if (this.typeInput.description == 'image') {
                this.disabled = true;
                this.contenido = '';
            } else {
                this.contenido = '';
                this.disabled = false;
            }

        },
        async getLisApiIcons() {
            let responseUser = await lisServices.getListApiIcons();
            this.iconsOptions = responseUser.list;
            console.log('Icons', this.iconsOptions);
        },
    },
};
</script>
<style>
.content {
    display: inline-flex !important;
    justify-content: space-between !important;
}

.icon-select {
    margin-top: 30px;
}
</style>
      